new Swiper('.block-cta__container', {
  // Optional parameters
  direction: 'horizontal',
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 15,
  breakpoints: {
    // when window width is >= 320px
    768: {
      allowTouchMove: false,
      spaceBetween: 0
    }
  },
  navigation: {
    nextEl: '.block-cta__pagination .swiper-button-next',
    prevEl: '.block-cta__pagination .swiper-button-prev'
  },
  pagination: {
    el: '.block-cta__pagination .swiper-pagination',
    clickable: true,
    renderBullet: function renderBullet(index, className) {
      return '<span class="' + className + '"> 0' + (index + 1) + '</span>';
    }
  }
});